import angular from 'angular';

import SpinnerIndicatorComponent from './spinner-indicator.cmpt';

export default angular
    .module('common.component.loader.component.spinner-indicator', [])
    .component(SpinnerIndicatorComponent.selector, SpinnerIndicatorComponent);



// WEBPACK FOOTER //
// ./src/common/component/loader/component/spinner-indicator/index.js